import { PRODUCT_FIND_MANY } from '../lib/endpoints/product';
import axios from '../lib/axios';
import { ProductMerchantModel } from '../models/productMerchant';

export const handleGetProductByItemCode = async (
  itemCode: string,
  setGetDataProduct: React.Dispatch<React.SetStateAction<ProductMerchantModel[]>>,
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
): Promise<void> => {
  try {
    const productResponse = await axios.post(`${PRODUCT_FIND_MANY}`, {
      filtter: { itemcode: itemCode },
    });
    const getProduct: ProductMerchantModel[] = productResponse?.data;
    if (getProduct?.length > 0) {

      // Create a map to store unique packType objects
      const packTypeMap: { [key: string]: ProductMerchantModel } = {};

      // Loop through each product and add to map if packType is not already present
      getProduct.forEach((item: ProductMerchantModel) => {
        const packType = item?.price?.masterProduct?.packType;
        if (packType && !packTypeMap[packType]) {
          packTypeMap[packType] = item;
        }
      });

      // Convert the map back to an array
      const getDataIsPackType: ProductMerchantModel[] = Object.values(packTypeMap);
      setGetDataProduct(getDataIsPackType);

      setErrorMessage('');
    } else {
      setErrorMessage('Item code is not found!!');
    }
  } catch (err) {
    setErrorMessage('Item code is not found!!');
  }
};
